import PortalWrp from './PortalWrp';
import PortalId from './constants';

export { PortalId };
export default PortalWrp;
